var BookmarkButton        = require("app/Bookmarks/BookmarkButton"),
    CoverVariables        = require("app/theme/styles/covers/CoverVariables"),
    CreditsList           = require("./CreditsList"),
    FollowButton          = require("app/Following/FollowButton"),
    IconButton            = require("app/ui/IconButton"),
    Image                 = require("app/ui/Image"),
    ImageOptimizerSupport = require("app/ui/ImageOptimizerSupport"),
    Layout                = require("./LargeMediaHeaderLayout"),
    MetadataList          = require("./MetadataList"),
    PlayMediaButton       = require("app/MediaPlayer/PlayMediaButton"),
    ShareButton           = require("app/Sharing/ShareButton"),
    SvgIcon               = require("app/ui/SvgIcon"),
    buttons               = require("app/theme/buttons"),
    findBestFittingCover  = require("app/utils/findBestFittingCover"),
    frameThrottle         = require("enyo-perf/utils").frameThrottle,
    get                   = require("object-path").get,
    humanizeTimespan      = require("app/utils/humanizeTimespan"),
    icons                 = require("app/theme/icons"),
    kind                  = require("enyo/kind"),
    utils                 = require("enyo/utils");

require("./LargeMediaHeader.less");

module.exports = kind(/** @lends app.ui.LargeMediaHeader.LargeMediaHeader.prototype */ {

    /**
     * @private
     */
    name: "app.ui.LargeMediaHeader.LargeMediaHeader",

    /**
     * @private
     */
    classes: "app-ui-large-media-header",

    /**
     * @private
     */
    layoutKind: Layout,

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @public
     */
    state: null,

    /**
     * @private
     */
    activeTab: "info",

    /**
     * @private
     */
    peekAtDashboard: false,

    /**
     * @private
     */
    components: [{
        name:       "background",
        classes:    "app-ui-large-media-header__background",
        components: [{
            classes:    "app-ui-large-media-header__background-image-wrapper",
            components: [{
                name:    "backgroundImage",
                kind:    Image,
                mixins:  [ImageOptimizerSupport],
                classes: "app-ui-large-media-header__background-image"
            }]
        }, {
            classes: "app-ui-large-media-header__gradient-left"
        }, {
            classes: "app-ui-large-media-header__gradient-bottom"
        }]
    }, {
        name:       "coverArea",
        classes:    "app-ui-large-media-header__cover-area",
        components: [{
            name:       "coverContainer",
            classes:    "app-ui-large-media-header__cover-container",
            components: [{
                name:    "cover",
                kind:    Image,
                mixins:  [ImageOptimizerSupport],
                classes: "app-ui-large-media-header__cover"
            }, {
                name:        "coverPlayMediaOverlay",
                kind:        PlayMediaButton,
                classes:     "app-ui-large-media-header__cover-play-media-overlay",
                theme:       buttons["app.ui.LargeMediaHeader.playMediaOverlay"],
                canGenerate: false
            }]
        }]
    }, {
        classes:    "app-ui-large-media-header__title-area",
        components: [{
            name:       "liveBadge",
            classes:    "app-ui-large-media-header__live-badge",
            components: [{
                name:    "liveBadgeIcon",
                kind:    SvgIcon,
                classes: "app-ui-large-media-header__live-badge-icon",
                icon:    icons["app.ui.LargeMediaHeader.liveBadgeIcon"]
            }, {
                name:    "liveBadgeCaption",
                classes: "app-ui-large-media-header__live-badge-caption"
            }]
        }, {
            name:    "title",
            classes: "app-ui-large-media-header__primary-title"
        }, {
            name:    "secondaryTitle",
            classes: "app-ui-large-media-header__secondary-title"
        }]
    }, {
        name:       "actions",
        classes:    "app-ui-large-media-header__actions",
        components: [{
            classes:    "app-ui-large-media-header__actions-left",
            components: [{
                name:    "playMediaButton",
                kind:    PlayMediaButton,
                classes: "app-ui-large-media-header__play-pause-button",
                theme:   buttons["app.ui.LargeMediaHeader.playMediaButton"]
            }, {
                name:    "bookmarkButton1",
                kind:    BookmarkButton,
                classes: "app-ui-large-media-header__bookmark-button-1",
                theme:   buttons["app.ui.LargeMediaHeader.bookmarkButton1"]
            }]
        }, {
            classes:    "app-ui-large-media-header__actions-right",
            components: [{
                name:           "bookmarkButton2",
                kind:           BookmarkButton,
                classes:        "app-ui-large-media-header__bookmark-button-2",
                theme:          buttons["app.ui.LargeMediaHeader.bookmarkButton2"],
                bookmarkIcon:   icons["app.Bookmarks.BookmarkButtonAlt.bookmark"],
                unbookmarkIcon: icons["app.Bookmarks.BookmarkButtonAlt.unbookmark"]
            }, {
                name:    "followButton",
                kind:    FollowButton,
                classes: "app-ui-large-media-header__follow-button",
                theme:   buttons["app.ui.LargeMediaHeader.followButton"]
            }, {
                name:    "shareButton",
                kind:    ShareButton,
                classes: "app-ui-large-media-header__share-button",
                theme:   buttons["app.ui.LargeMediaHeader.shareButton"]
            }]
        }]
    }, {
        classes:    "app-ui-large-media-header__tabs",
        components: [{
            name:    "infoTab",
            kind:    IconButton,
            classes: "app-ui-large-media-header__tab",
            theme:   buttons["app.ui.LargeMediaHeader.TabBar.tab"],
            caption: "info",
            tab:     "info",
            ontap:   "onTabTap"
        }, {
            name:    "creditsTab",
            kind:    IconButton,
            classes: "app-ui-large-media-header__tab",
            theme:   buttons["app.ui.LargeMediaHeader.TabBar.tab"],
            caption: "credits",
            tab:     "credits",
            ontap:   "onTabTap"
        }]
    }, {
        name:       "info",
        classes:    "app-ui-large-media-header__info",
        components: [{
            name:      "body",
            allowHtml: true,
            classes:   "app-ui-large-media-header__body"
        }, {
            name:    "metadataList",
            kind:    MetadataList,
            classes: "app-ui-large-media-header__metadata-list"
        }],
        tab: "info"
    }, {
        name:       "credits",
        classes:    "app-ui-large-media-header__credits",
        components: [{
            name:    "creditsTitle",
            classes: "app-ui-large-media-header__credits-title"
        }, {
            name:    "creditsList",
            kind:    CreditsList,
            classes: "app-ui-large-media-header__credit-list"
        }],
        tab: "credits"
    }],

    /**
     * @private
     */
    observers: {
        updateAndResize: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.lazyResize             = frameThrottle(this.bindSafely(this.resize));
            this.updateAndResize        = frameThrottle(this.bindSafely(this.updateAndResize));
            this.updateLivestreamStatus = this.bindSafely(this.updateLivestreamStatus);
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.updateAndResize);
            this.observe("app.$.authService.isLoggedIn", this.updateAndResize);
            this.updateAndResize();
            this.activeTabChanged();
        };
    }),

    /**
     * This component needs to resize after it's been updated, but we want the
     * update function to be extensible. This method allows us to resize after
     * all updates are done.
     *
     * @private
     */
    updateAndResize: function() {
        this.update();
        this.resize();
    },

    /**
     * @public
     */
    update: function() {
        var $i18nService           = this.app.$.i18nService,
            state                  = this.state || {},
            mediaItem              = get(state, "data", null),
            mediaType              = get(mediaItem, "type", null),
            isLivestream           = get(mediaItem, "is_livestream", false),
            title                  = get(mediaItem, "meta.title", null),
            secondaryTitle         = get(mediaItem, "meta.secondary_title", null),
            description            = get(mediaItem, "meta.html_long_description", null),
            artists                = get(mediaItem, "artists", []),
            year                   = get(mediaItem, "year", null),
            credits                = get(mediaItem, "credits", []),
            dashboard              = get(mediaItem, "dashboard", []),
            coverRatio             = CoverVariables.getAspectRatio("portrait"),
            cover                  = findBestFittingCover(mediaItem || {}, coverRatio),
            metadata               = [],
            $backgroundImage       = this.$.backgroundImage,
            $cover                 = this.$.cover,
            $coverPlayMediaOverlay = this.$.coverPlayMediaOverlay,
            $title                 = this.$.title,
            $secondaryTitle        = this.$.secondaryTitle,
            $playMediaButton       = this.$.playMediaButton,
            $bookmarkButton1       = this.$.bookmarkButton1,
            $bookmarkButton2       = this.$.bookmarkButton2,
            $followButton          = this.$.followButton,
            $shareButton           = this.$.shareButton,
            $infoTab               = this.$.infoTab,
            $creditsTab            = this.$.creditsTab,
            $body                  = this.$.body,
            $metadataList          = this.$.metadataList,
            $creditsTitle          = this.$.creditsTitle,
            $creditsList           = this.$.creditsList;

        if (artists.length > 0 && artists.join(", ") !== secondaryTitle) {
            if (artists.length === 1) {
                metadata.push({
                    id:    utils.uid(),
                    label: $i18nService.getString("app.ui.header.MetadataListItem.artist"),
                    value: artists[0]
                });
            }
            else {
                metadata.push({
                    id:    utils.uid(),
                    label: $i18nService.getString("app.ui.header.MetadataListItem.artists"),
                    value: artists.join(", ")
                });
            }
        }

        if (year !== null) {
            metadata.push({
                id:    utils.uid(),
                label: $i18nService.getString("app.ui.header.MetadataListItem.year"),
                value: year
            });
        }

        $backgroundImage.set("rawImageSrc", cover ? {
            width:  cover.width || null,
            height: cover.height || null,
            ratio:  cover.aspect_ratio || null,
            src:    get(cover, "url", null)
        } : null, {
            silent: true
        });

        $cover.set("rawImageSrc", cover ? {
            width:  cover.width || null,
            height: cover.height || null,
            ratio:  cover.aspect_ratio || null,
            src:    get(cover, "url", null)
        } : null, {
            silent: true
        });

        switch (mediaType) {
            case "audio":
                $coverPlayMediaOverlay.set("caption", $i18nService.getString("app.ui.LargeMediaHeader.ListenButton.caption"));
                $coverPlayMediaOverlay.set("tooltip", $i18nService.getString("app.ui.LargeMediaHeader.ListenButton.tooltip"));
                $coverPlayMediaOverlay.set("mediaItem", mediaItem);
                break;
            case "video":
                $coverPlayMediaOverlay.set("caption", $i18nService.getString("app.ui.LargeMediaHeader.PlayButton.caption"));
                $coverPlayMediaOverlay.set("tooltip", $i18nService.getString("app.ui.LargeMediaHeader.PlayButton.tooltip"));
                $coverPlayMediaOverlay.set("mediaItem", mediaItem);
                break;
            case "book":
                $coverPlayMediaOverlay.set("caption", $i18nService.getString("app.ui.LargeMediaHeader.ReadButton.caption"));
                $coverPlayMediaOverlay.set("tooltip", $i18nService.getString("app.ui.LargeMediaHeader.ReadButton.tooltip"));
                $coverPlayMediaOverlay.set("mediaItem", mediaItem);
                break;
            default:
                $coverPlayMediaOverlay.set("caption", "");
                $coverPlayMediaOverlay.set("tooltip", "");
                $coverPlayMediaOverlay.set("mediaItem", null);
                break;
        }

        if (isLivestream) {
            this.startLivestreamStatus(
                Date.parse(get(mediaItem, "datetime_livestream_start", 0)) / 1000,
                Date.parse(get(mediaItem, "datetime_livestream_end", 0)) / 1000
            );
        }
        else {
            this.stopLivestreamStatus();
        }

        // Title
        $title.set("content", title || "");

        $secondaryTitle.set("showing", Boolean(secondaryTitle));
        $secondaryTitle.set("content", secondaryTitle);

        // Play button
        switch (mediaType) {
            case "audio":
                $playMediaButton.set("caption", $i18nService.getString("app.ui.LargeMediaHeader.ListenButton.caption"));
                $playMediaButton.set("tooltip", $i18nService.getString("app.ui.LargeMediaHeader.ListenButton.tooltip"));
                $playMediaButton.set("mediaItem", mediaItem);
                break;
            case "video":
                $playMediaButton.set("caption", $i18nService.getString("app.ui.LargeMediaHeader.PlayButton.caption"));
                $playMediaButton.set("tooltip", $i18nService.getString("app.ui.LargeMediaHeader.PlayButton.tooltip"));
                $playMediaButton.set("mediaItem", mediaItem);
                break;
            case "book":
                $playMediaButton.set("caption", $i18nService.getString("app.ui.LargeMediaHeader.ReadButton.caption"));
                $playMediaButton.set("tooltip", $i18nService.getString("app.ui.LargeMediaHeader.ReadButton.tooltip"));
                $playMediaButton.set("mediaItem", mediaItem);
                break;
            default:
                $playMediaButton.set("caption", "");
                $playMediaButton.set("tooltip", "");
                $playMediaButton.set("mediaItem", null);
                break;
        }

        $bookmarkButton1.set("mediaItem", mediaItem);
        $bookmarkButton2.set("mediaItem", mediaItem);
        $followButton.set("mediaItem", mediaItem);
        $shareButton.set("mediaItem", mediaItem);

        $infoTab.set("caption", $i18nService.getString("app.ui.LargeMediaHeader.TabBar.InfoTab.caption"));
        $infoTab.set("tooltip", $i18nService.getString("app.ui.LargeMediaHeader.TabBar.InfoTab.tooltip", {
            mediaType: mediaType
        }));

        $creditsTab.set("caption", $i18nService.getString("app.ui.LargeMediaHeader.TabBar.CreditsTab.caption"));
        $creditsTab.set("tooltip", $i18nService.getString("app.ui.LargeMediaHeader.TabBar.CreditsTab.tooltip"));

        $creditsTitle.set("content", $i18nService.getString("app.ui.LargeMediaHeader.creditsTitle"));

        $body.set("content", description || "");

        $metadataList.set("showing", metadata.length > 0);
        $metadataList.set("data", metadata);

        if (credits.length > 0) {
            if (!this.hasClass("has-credits")) {
                this.addClass("has-credits");
            }
        }
        else {
            while (this.hasClass("has-credits")) {
                this.removeClass("has-credits");
            }
        }
        $creditsList.set("data", credits);

        this.set("peekAtDashboard", dashboard.length > 0);
    },

    /**
     * Start the loop that checks the status of the livestream
     *
     * @param  {Number}  start  The start of the live-stream as Unix Timestamp
     *                          in seconds
     * @param  {Number}  end    The end of the live-stream as Unix Timestamp in
     *                          seconds
     * @public
     */
    startLivestreamStatus: function(start, end) {
        this.updateLivestreamStatus(start, end);
        this.app.$.countdownService.request(this.id + "::updateLivestreamStatus", this.bindSafely(function() {
            this.updateLivestreamStatus(start, end);
        }));
    },

    /**
     * Update the status of the livestream
     *
     * @param  {Number}  start  The start of the live-stream as Unix Timestamp
     *                          in seconds
     * @param  {Number}  end    The end of the live-stream as Unix Timestamp in
     *                          seconds
     * @public
     */
    updateLivestreamStatus: function(start, end) {
        var $i18nService      = this.app.$.i18nService,
            $countdownService = this.app.$.countdownService,
            language          = $i18nService.get("language"),
            now               = Date.now() / 1000,
            eta,
            humanizedEta,
            $liveBadge        = this.$.liveBadge,
            $liveBadgeCaption = this.$.liveBadgeCaption;

        // Livestream pending
        if (start > now) {
            eta          = start - now;
            humanizedEta = humanizeTimespan(eta, language, true);
            $liveBadgeCaption.set("content", $i18nService.getString("app.ui.LargeMediaHeader.LiveBadge.livePendingLabel", {
                eta: humanizedEta
            }));
            $liveBadge.setAttribute("data-live-status", "pending");
            $countdownService.request(this.id + "::updateLivestreamStatus", this.bindSafely(function() {
                this.updateLivestreamStatus(start, end);
            }));
        }

        // Now live streaming
        else if (start <= now && now < end) {
            $liveBadgeCaption.set("content", $i18nService.getString("app.ui.LargeMediaHeader.LiveBadge.liveLabel"));
            $liveBadge.setAttribute("data-live-status", "live");
            $countdownService.request(this.id + "::updateLivestreamStatus", this.bindSafely(function() {
                this.updateLivestreamStatus(start, end);
            }));
        }

        // Stream done
        else {
            this.stopLivestreamStatus();
        }
    },

    /**
     * Stop updating the livestream status
     *
     * @public
     */
    stopLivestreamStatus: function() {
        var $liveBadge        = this.$.liveBadge,
            $liveBadgeCaption = this.$.liveBadgeCaption;

        $liveBadgeCaption.set("content", "");
        $liveBadge.setAttribute("data-live-status", "finished");
        this.app.$.countdownService.cancel(this.id + "::updateLivestreamStatus");
    },

    /**
     * @param    {enyo.Control}  sender  The sender
     * @returns  {boolean}       Whether to stop event propagation.
     * @private
     */
    onTabTap: function(sender) {
        this.set("activeTab", sender.get("tab"));

        return true;
    },

    /**
     * @private
     */
    activeTabChanged: function() {
        var $infoTab    = this.$.infoTab,
            $creditsTab = this.$.creditsTab,
            activeTab;

        activeTab = this.get("activeTab");

        [$infoTab, $creditsTab].forEach(function($tab) {
            var tab;

            tab = $tab.get("tab");

            if (tab && tab === activeTab) {
                if (!$tab.hasClass("active")) {
                    $tab.addClass("active");
                }
            }
            else if (tab && tab !== activeTab) {
                while ($tab.hasClass("active")) {
                    $tab.removeClass("active");
                }
            }
        });

        this.lazyResize();
    }

});
